import React from "react";
import { useMutation, useQueryClient } from "react-query";
import { useCookie } from "../../../hooks/useCookie";
import { useToast } from "../../../hooks/useToast";
import { general } from "../../../locales/general";
import apiService from "../../../service/apiService";
import { TranslationRow, TranslationTable } from "../Translationtableparts";

function TableBodyRowContent({
  eventTranslation,
  deletedList,
}: {
  eventTranslation: EventTranslation;
  deletedList: React.Dispatch<BulkDeleteActions>;
}) {
  const { toastSuccess, toastError } = useToast();
  const { token } = useCookie("vToken");
  const queryClient = useQueryClient();

  const deleteEventTranslation = useMutation((id: string) => {
    return apiService.MakeDeleteRequest(`event-translations/${id}`, token);
  });

  const removeEventTranslation = () => {
    deleteEventTranslation.mutate(eventTranslation.id, {
      onError(error) {
        console.log(error);
        toastError(general.fr.message.operationFailed);
      },
      onSuccess() {
        toastSuccess(general.fr.message.partnerDeleted);
        queryClient.invalidateQueries("getAllTranslations");
      },
    });
  };

  return (
    <TranslationRow
      id={eventTranslation.id}
      deletedList={deletedList}
      withImage
      image={eventTranslation.event?.image}
      sourceTitle={eventTranslation.event?.name}
      translation={eventTranslation?.name}
      lang={eventTranslation?.lang}
      editTo={`/event-translations/update/${eventTranslation.id}`}
      onDelete={removeEventTranslation}
      isDeleting={deleteEventTranslation.isLoading}
    />
  );
}

interface TableProps {
  eventTranslations: EventTranslation[];
  eventTranslationsToBeDeleted: React.Dispatch<BulkDeleteActions>;
}

export default function EventTranslationsTable({
  eventTranslations,
  eventTranslationsToBeDeleted,
}: TableProps) {
  return (
    <TranslationTable sourceLabel="Évènement">
      {eventTranslations?.map((eventTranslation) => (
        <TableBodyRowContent
          eventTranslation={eventTranslation}
          key={eventTranslation?.id}
          deletedList={eventTranslationsToBeDeleted}
        />
      ))}
    </TranslationTable>
  );
}
